const nested_col_pi_pi = [
    {title: 'Res 1', key: 0, render: (row) => row[1] + row[2] + "_" + row[3]},
    {title: 'Res 2', key: 1, render: (row) => row[4] + row[5] + "_" + row[6]},
    {title: 'Distance', dataIndex: 7, key: 6, render: (value) => parseFloat(value).toFixed(2)},
    {title: 'Theta', dataIndex: 8, key: 7, render: (value) => parseFloat(value).toFixed(2)},
    {title: 'Gamma', dataIndex: 9, key: 8, render: (value) => parseFloat(value).toFixed(2)},
    /*{
        title: 'Show/Hide',
        key: 'action',
        render: (_, record) => {
            const isVisible = false;
            return (
                <Button
                    icon={isVisible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                    onClick={() => console.log(record)}
                />
            );
        },
    }*/];

const nested_col_proximal = [
    {title: 'Res 1', key: 0, render: (row) => row[1] + row[2] + "_" + row[3]},
    {title: 'Res 2', key: 1, render: (row) => row[4] + row[5] + "_" + row[6]},
    {title: 'Atom 1', dataIndex: 7, key: 6},
    {title: 'Atom 2', dataIndex: 8, key: 7,},
    {title: 'Distance', dataIndex: 9, key: 8, render: (value) => parseFloat(value).toFixed(2)}];

const nested_col_h_bond = [
    {title: 'Res 1', key: 0, render: (row) => row[1] + row[2] + "_" + row[3]},
    {title: 'Res 2', key: 1, render: (row) => row[4] + row[5] + "_" + row[6]},
    {title: 'Atom 1', dataIndex: 7, key: 6},
    {title: 'Atom 2', dataIndex: 8, key: 7,},
    {title: 'Distance', dataIndex: 9, key: 8, render: (value) => parseFloat(value).toFixed(2)},
    {title: 'Angle', dataIndex: 10, key: 9}];

const nested_col_cho_n = [
    {title: 'Res 1', key: 0, render: (row) => row[1] + row[2] + "_" + row[3]},
    {title: 'Res 2', key: 1, render: (row) => row[4] + row[5] + "_" + row[6]},
    {title: 'Atom 1', dataIndex: 7, key: 6},
    {title: 'Atom 2', dataIndex: 8, key: 7,},
    {title: 'Distance', dataIndex: 9, key: 8, render: (value) => parseFloat(value).toFixed(2)},
    {title: 'Angle', dataIndex: 10, key: 9, render: (value) => parseFloat(value).toFixed(2)},
    {title: 'Theta', dataIndex: 11, key: 9},
    {title: 'H Atom', dataIndex: 12, key: 9}];

const nested_col_lone_pi = [
    {title: 'Res 1', key: 0, render: (row) => row[1] + row[2] + "_" + row[3]},
    {title: 'Res 2', key: 1, render: (row) => row[4] + row[5] + "_" + row[6]},
    {title: 'Distance', dataIndex: 7, key: 8, render: (value) => parseFloat(value).toFixed(2)},
    {title: 'Lone_pair Atom', dataIndex: 8, key: 9},
    {title: 'Lone_pair From', dataIndex: 9, key: 9},
    {title: 'Ring From', dataIndex: 10, key: 9}];

const nested_col_cation_pi = [
    {title: 'Res 1', key: 0, render: (row) => row[1] + row[2] + "_" + row[3]},
    {title: 'Res 2', key: 1, render: (row) => row[4] + row[5] + "_" + row[6]},
    {title: 'Distance', dataIndex: 7, key: 8, render: (value) => parseFloat(value).toFixed(2)},
    {title: 'Cation Atom', dataIndex: 8, key: 9},
    {title: 'Cation From', dataIndex: 9, key: 9},
    {title: 'Ring From', dataIndex: 10, key: 9}];

//,Res. Name 1,Res. Number 1,Chain 1,Res. Name 2,Res. Number 2,Chain 2,Atom 1,Atom 2,Distance from Res 1,Distance from Res 2,Water Identity
const nested_water_mediated = [
    {title: 'Res 1', key: 0, render: (row) => row[1] + row[2] + "_" + row[3]},
    {title: 'Res 2', key: 1, render: (row) => row[4] + row[5] + "_" + row[6]},
    {title: 'Atom 1', dataIndex: 7, key: 8},
    {title: 'Atom 2', dataIndex: 8, key: 9},
    {title: 'Distance from Res 1', dataIndex: 9, key: 10, render: (value) => parseFloat(value).toFixed(2)},
    {title: 'Distance from Res 2', dataIndex: 10, key: 11, render: (value) => parseFloat(value).toFixed(2)},
    {title: 'Water Identity', dataIndex: 11, key: 12}];

const nested_water_mediated_alt = [
    {title: 'Res 1', key: 0, render: (row) => row[1] + row[2] + "_" + row[3]},
    {title: 'Res 2', key: 1, render: (row) => row[4] + row[5] + "_" + row[6]},
    {title: 'Atom 1', dataIndex: 7, key: 8},
    {title: 'Atom 2', dataIndex: 8, key: 9},
    {title: 'Distance from Res 1', dataIndex: 9, key: 10, render: (value) => parseFloat(value).toFixed(2)},
    {title: 'Distance from Res 2', dataIndex: 10, key: 11, render: (value) => parseFloat(value).toFixed(2)},
    {title: 'Water Identity', dataIndex: 11, key: 12}];


//,Res. Name 1,Res. Number 1,Chain 1,Res. Name 2,Res. Number 2,Chain 2,Atom 1,Atom 2,Distance from Res 1,Distance from Res 2,Metal Identity
const nested_metal_mediated = [
    {title: 'Res 1', key: 0, render: (row) => row[1] + row[2] + "_" + row[3]},
    {title: 'Res 2', key: 1, render: (row) => row[4] + row[5] + "_" + row[6]},
    {title: 'Atom 1', dataIndex: 7, key: 8},
    {title: 'Atom 2', dataIndex: 8, key: 9},
    {title: 'Distance from Res 1', dataIndex: 9, key: 10, render: (value) => parseFloat(value).toFixed(2)},
    {title: 'Distance from Res 2', dataIndex: 10, key: 11, render: (value) => parseFloat(value).toFixed(2)},
    {title: 'Metal Identity', dataIndex: 11, key: 12}];

//,Res. Name 1,Res. Number 1,Chain 1,Res. Name 2,Res. Number 2,Chain 2,Atom 1,Atom 2,Theta 1,Theta 2
const nested_halogen_bond = [
    {title: 'Res 1', key: 0, render: (row) => row[1] + row[2] + "_" + row[3]},
    {title: 'Res 2', key: 1, render: (row) => row[4] + row[5] + "_" + row[6]},
    {title: 'Atom 1', dataIndex: 7, key: 8},
    {title: 'Atom 2', dataIndex: 8, key: 9},
    {title: 'Theta 1', dataIndex: 9, key: 10},
    {title: 'Theta 2', dataIndex: 10, key: 11}];

//,Res. Name 1,Res. Number 1,Chain 1,Res. Name 2,Res. Number 2,Chain 2,Distance (Å),Anion From,Ring From
const nested_anion_pi = [
    {title: 'Res 1', key: 0, render: (row) => row[1] + row[2] + "_" + row[3]},
    {title: 'Res 2', key: 1, render: (row) => row[4] + row[5] + "_" + row[6]},
    {title: 'Distance (Å)', dataIndex: 7, key: 8, render: (value) => parseFloat(value).toFixed(2)},
    {title: 'Anion Atom', dataIndex: 8, key: 9},
    {title: 'Anion From', dataIndex: 9, key: 10},
    {title: 'Ring From', dataIndex: 10, key: 11}];

//,Res. Name 1,Res. Number 1,Chain 1,Res. Name 2,Res. Number 2,Chain 2,Distance (Å),Polar Atom,Polar From,Ring From
const nested_polar_pi = [
    {title: 'Res 1', key: 0, render: (row) => row[1] + row[2] + "_" + row[3]},
    {title: 'Res 2', key: 1, render: (row) => row[4] + row[5] + "_" + row[6]},
    {title: 'Distance (Å)', dataIndex: 7, key: 8, render: (value) => parseFloat(value).toFixed(2)},
    {title: 'Polar Atom', dataIndex: 8, key: 9},
    {title: 'Polar From', dataIndex: 9, key: 10},
    {title: 'Ring From', dataIndex: 10, key: 11}];

//,Res. Name 1,Res. Number 1,Chain 1,Res. Name 2,Res. Number 2,Chain 2,Distance (Å),C Atom,H Atom,C Atom From,Ring From,Alpha °,BETA °
const nested_ch_pi = [
    {title: 'Res 1', key: 0, render: (row) => row[1] + row[2] + "_" + row[3]},
    {title: 'Res 2', key: 1, render: (row) => row[4] + row[5] + "_" + row[6]},
    {title: 'Distance (Å)', dataIndex: 7, key: 8, render: (value) => parseFloat(value).toFixed(2)},
    {title: 'C Atom', dataIndex: 8, key: 9},
    {title: 'H Atom', dataIndex: 9, key: 10},
    {title: 'C Atom From', dataIndex: 10, key: 11},
    {title: 'Ring From', dataIndex: 11, key: 12},
    {title: 'Alpha °', dataIndex: 12, key: 13},
    {title: 'BETA °', dataIndex: 13, key: 14}];

export const NESTED_COLS = {
    'π-π interaction': nested_col_pi_pi,
    'Proximal contact': nested_col_proximal,
    'H-bond*': nested_col_h_bond,
    'H-bond': nested_col_h_bond,
    'Apolar vdW contact': nested_col_proximal,
    'CH-O/N bond': nested_col_cho_n,
    'lp-π interaction': nested_col_lone_pi,
    'Cation-π interaction': nested_col_cation_pi,
    'Clash': nested_col_proximal,
    'Salt-bridge': nested_col_proximal,
    'Polar vdW contact': nested_col_proximal,
    'Water mediated contact': nested_water_mediated_alt,//nested_water_mediated,
    'Metal mediated contact': nested_metal_mediated,
    'S-bond': nested_col_proximal,
    'S-S Bond': nested_col_proximal,
    'Halogen bond': nested_halogen_bond,
    'Anion-π interaction': nested_anion_pi,
    'Amino-π interaction': nested_polar_pi,
    'CH-π interaction': nested_ch_pi,
    'O/N/SH-π interaction': nested_ch_pi, //uguale a O/N/SH- π Interaction
}